import React, {useState} from "react";
import {Tooltip} from "@material-ui/core";
import copy from 'clipboard-copy'

export default function C2c(props) {
    const [showTooltip, setShowToolTip] = useState(false);
    const onCopy = (content) => {
        copy(content);
        setShowToolTip(true)
    };
    const handleOnTooltipClose = () => {
        setShowToolTip(false)
    };
    return (
        <Tooltip
            open={showTooltip}
            title={"in die Zwischenablage kopiert!"}
            leaveDelay={1500}
            onClose={handleOnTooltipClose}
            {...props.TooltipProps || {}}
        >
            {props.children({copy: onCopy})}
        </Tooltip>
    );
}
